import { createFileRoute } from "@tanstack/react-router";
import { ClientDetailPageLayout } from "../../../pages/clients-page/client-detail-page-layout";

export const Route = createFileRoute("/_auth/_frame/clients/$companyId")({
  component: ClientDetailPageLayout,
});
